/*
 * File: CurrencyInput.tsx
 * Author: Austin Robinson
 * Date Created: 10/6/2023
 * Copyright (c) DrivingDoc 2023
 */
import { StandardTextFieldProps, TextField, TextFieldProps } from '@mui/material';
import { useController, useFormContext } from 'react-hook-form';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface PropTypes extends Omit<StandardTextFieldProps, 'variant'> {
  name: string;
  label: string;
  numericFormatProps?: Omit<NumericFormatProps, keyof TextFieldProps>;
  multiplier?: number;
}

// const defaultTextFieldProps: TextFieldProps = {
//     variant: 'standard',
//     InputLabelProps: {
//         shrink: true
//     },
//     InputProps: {
//         startAdornment: <InputAdornment position="start">$</InputAdornment>,

//     },
// };

export default function NumericFormatInput({
  name,
  label,
  numericFormatProps,
  multiplier = 1,
  ...textFieldProps
}: PropTypes) {
  const { control } = useFormContext();
  const { field, fieldState } = useController({ control, name });
  return (
    <NumericFormat
      {...numericFormatProps}
      // allowLeadingZeros={false}
      // allowNegative={false}
      // decimalScale={2}
      // fixedDecimalScale
      // thousandsGroupStyle="thousand"
      // thousandSeparator=","
      customInput={TextField}
      name={name}
      label={label}
      variant="standard"
      fullWidth
      slotProps={{
        // input: {
        //     startAdornment: <InputAdornment position="start">$</InputAdornment>,
        // },
        inputLabel: {
          shrink: true,
        },
      }}
      error={!!fieldState.error}
      helperText={fieldState.error?.message}
      getInputRef={field.ref}
      // @ts-expect-error: field.value is unknown, but it is safely at runtime
      value={typeof field.value === 'number' ? field.value / multiplier : 0}
      onBlur={field.onBlur}
      onValueChange={(values) => {
        field.onChange(Number((values.floatValue ?? 0) * multiplier));
      }}
      {...textFieldProps}
    />
  );
}
